import React from 'react';

import { TriggerDTO } from '@peartherapeutics/hylia-api-client';
import Bar from '../Overview/WidgetSubstanceUse/Bar';

import styles from './styles.module.scss';

interface ITriggerChart {
  triggers: TriggerDTO[];
}

const TriggerChart = (props: ITriggerChart) => {
  const { triggers } = props;

  return (
    <div className={styles.wrapper} data-testid="trigger-chart">
      <Bar triggers={triggers} />
    </div>
  );
};

export default TriggerChart;
